import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, useSlots } from 'vue';
import defaultImage from '@/assets/img/empty/default.png';
var __default__ = {
    name: 'XEmpty',
    inheritAttrs: false
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        centeredInContent: {
            type: Boolean,
            default: false
        },
        image: String,
        description: String
    },
    setup: function setup(__props) {
        var props = __props;
        var slots = useSlots();
        var emptyImage = computed(function() {
            var _props_image;
            if (slots.image) {
                return '';
            }
            return (_props_image = props.image) !== null && _props_image !== void 0 ? _props_image : defaultImage;
        });
        var emptyDescription = computed(function() {
            if (slots.description) {
                return '';
            }
            return props.description;
        });
        return {
            __sfc: true,
            props: props,
            slots: slots,
            emptyImage: emptyImage,
            emptyDescription: emptyDescription
        };
    }
}));
